import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import { createQueryString, getBaseURL } from 'lib/utility/GetBaseUrl'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const suburbsEndpoints = {
  fetchSuburbs: (suburb: string) => {
    const query = {
      filters: { search: suburb },
      old_filter: true,
    }
    const URL = `${getBaseURL()}/api/v2/suburbs?${createQueryString(query)}`

    return axiosRequest().get(URL)
  },
}

const suburbsAPI = {
  fetchSuburbs: (suburb: string) =>
    apiWrapper({
      endPoint: suburbsEndpoints.fetchSuburbs,
      params: suburb,
      errorFailureAction: handleStatus500,
    }),
}

export default suburbsAPI
